import type { Observation } from "@medplum/fhirtypes";
import { OBSERVATION_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

/**
 * Hook that subscribes to Observation resource changes via WebSocket
 * and updates the TanStack DB collection in real-time.
 *
 * Must be used inside FhirDataStoreProvider.
 */
export const useObservationSubscription = createSubscriptionHook<Observation>(
  "Observation",
  OBSERVATION_COLLECTION_NAME,
);
